<template functional>
    <v-card flat tile outlined color="primary" class="fill-height">
        <v-card flat tile outlined color="white" class="px-3 fill-height">
            <v-row justify="center" align="center" class="fill-height">
                <v-col cols="auto">
                    <v-icon size="36" color="primary">{{ props.icon }}</v-icon>
                </v-col>
                <v-col>
                    <div class="subtitle-1 text-uppercase font-weight-bold primary--text">{{ props.label }}</div>
                </v-col>
                <v-col cols="12" lg="auto">
                    <div class="display-1 font-weight-bold text-center">{{ props.value }}</div>
                </v-col>
            </v-row>
        </v-card>
    </v-card>
</template>

<script>
    export default {
        props: {
            icon: {
                type: String,
                required: true
            },
            value: {
                type: Number,
                required: true
            },
            label: {
                type: String,
                required: true
            }
        }
    };
</script>
